import React, { useState, useRef } from 'react';
import { Button, Dropdown } from 'react-bootstrap';
import { createPortal } from 'react-dom';
import { pdf } from '@react-pdf/renderer';
import * as XLSX from 'xlsx';
import BillingInvoiceGroup from './BillingInvoiceGroup'; // your PDF component
import axiosWrapper from '../../../../utils/api';
import { API_URL } from '../../../../utils/apiUrl';
import { useSelector } from 'react-redux';
import { formatDate } from '../../../../utils/common';

const InvoiceDownloadRenderer = ({ data: rowData }) => {
    const dropdownToggleRef = useRef(null);
    const [dropdownPosition, setDropdownPosition] = useState({});
    const [showDropdown, setShowDropdown] = useState(false);
    const { userToken } = useSelector((state) => state.auth);

    const handleToggle = (isOpen) => {
        if (isOpen) {
            // Get the bounding box for positioning the dropdown
            const boundingRect = dropdownToggleRef.current.getBoundingClientRect();
            setDropdownPosition({
                top: boundingRect.top + boundingRect.height,
                left: boundingRect.left
            });
        }
        setShowDropdown(isOpen);
    };

    const handleDownloadInvoiceOption = async (option) => {
        // rowData contains invoice info, e.g. rowData._id
        const invoiceId = rowData?._id;
        if (!invoiceId) return;

        const response = await axiosWrapper('get', API_URL.GET_INVOICE_BY_ID(invoiceId), {}, userToken);
        if (response?.success && response?.data) {
            const invoiceData = response.data;
            if (option === 'pdf') {
                // PDF download
                const blob = await pdf(<BillingInvoiceGroup data={invoiceData} />).toBlob();
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Invoice-${invoiceData?.invoice?.invoiceNumber}.pdf`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            } else if (option === 'csv') {
                const flattenedInvoiceData = {
                    InvoiceID: invoiceData?._id,
                    'Group Admin First Name': invoiceData?.groupAdmin?.firstName,
                    'Group Admin Last Name': invoiceData?.groupAdmin?.lastName,
                    'Group Name': invoiceData?.groupAdmin?.groupName,
                    'Street Address': invoiceData?.groupAdmin?.streetAddress,
                    'Street Address 2': invoiceData?.groupAdmin?.streetAddress2,
                    City: invoiceData?.groupAdmin?.city,
                    State: invoiceData?.groupAdmin?.state,
                    ZipCode: invoiceData?.groupAdmin?.zipCode,
                    Title: invoiceData?.groupAdmin?.title,
                    InvoiceNumber: invoiceData?.invoice?.invoiceNumber,
                    InvoiceTotal: invoiceData?.invoice?.invoiceTotal,
                    ProcessingFee: invoiceData?.invoice?.processingFee,
                    DueDate: formatDate(invoiceData?.invoice?.dueDate),
                    Status: invoiceData?.invoice?.status,
                    CreatedAt: formatDate(invoiceData?.invoice?.createdAt)
                };

                // 2) Convert flattened data to a sheet and workbook
                const worksheet = XLSX.utils.json_to_sheet([flattenedInvoiceData]);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Invoice');

                // 3) Write the CSV file
                XLSX.writeFile(workbook, `Invoice-${invoiceData?.invoice?.invoiceNumber}.csv`);
            }
        }
    };

    return (
        <div className="actions-div" ref={dropdownToggleRef}>
            <Dropdown show={showDropdown} onToggle={handleToggle}>
                <Dropdown.Toggle variant="primary" className="manage-btn" id="dropdown-basic">
                    Download
                </Dropdown.Toggle>
                {showDropdown &&
                    createPortal(
                        <div
                            style={{
                                position: 'absolute',
                                top: dropdownPosition.top,
                                left: dropdownPosition.left,
                                zIndex: 9999
                            }}
                        >
                            <Dropdown.Menu show>
                                <Dropdown.Item onClick={() => handleDownloadInvoiceOption('pdf')}>
                                    Download PDF
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => handleDownloadInvoiceOption('csv')}>
                                    Download CSV
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </div>,
                        document.body
                    )}
            </Dropdown>
        </div>
    );
};

export default InvoiceDownloadRenderer;
